module.exports = __webpack_public_path__ + "img/ran-compute.png";